import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useTheme, buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import fr from 'facet-rest';
import ListItemText from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/ListItemText';
import moment from 'moment/moment';
import { getStartOfDayLocalFromUTC } from 'Helpers/DateTime';
import { DataValueMap } from 'Helpers/Testing';

const useStyles = buildUseStyles('ThreadListItemDateAndQuickActions', (theme) => ({
  root: {
  },
  date: {
    flex: '0 0 auto',
    textAlign: 'end',
    marginRight: theme.spacing(0.5),
    marginBottom: theme.spacing(0),
    whiteSpace: 'nowrap',
  },
  dateText: {
    color: theme.palette.facet.primaryGray4,
  },
  unread: {
    fontWeight: theme.typography.fontWeightExtraBold,
    color: theme.palette.text.primary,
  },
}));

const ThreadListItemDate = ({
  threadResource,
}) => {
  const theme = useTheme();
  const classes = useStyles(theme);

  const isUnread = threadResource.isTruthy('isUnread');
  const lastMessageDate = threadResource.attr('previewMessageDate'); // TODO: This needs to be replaced with the proper value when it exists
  const timestamp = moment(lastMessageDate);
  let timeText = timestamp.format('L'); // Display as 09/06/2022
  // If within the year, display as '09/26"
  if (moment().year() === timestamp.year()) {
    timeText = timestamp.format('MM/DD');
  }
  // If within the week, display as 'X s/min/h/d (s) ago' ex. "1d ago"
  if (moment().diff(moment(getStartOfDayLocalFromUTC(lastMessageDate)), 'weeks') === 0) {
    timeText = `${timestamp.fromNow()} ago`;
  }

  return (
    <ListItemText
      className={classes.date}
      primary={timeText}
      primaryTypographyProps={{
        className: classNames(classes.text, classes.dateText, { [classes.unread]: isUnread }),
      }}
      {...DataValueMap
        .init('messages-page-thread-list-item-datetime')
        .append(DataValueMap.keyMap.dataResourceId, threadResource.id())
        .build()}
    />
  );
};

ThreadListItemDate.defaultProps = {
};

ThreadListItemDate.propTypes = {
  threadResource: PropTypes.instanceOf(fr.Resource).isRequired,
};

export { ThreadListItemDate };
